var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "上传费用凭证",
        visible: _vm.dialogVisible,
        width: "800px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: { "label-position": "top" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "receiveAmount", label: "费用" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "请输入费用",
                                "suffix-icon": "USD",
                              },
                              model: {
                                value: _vm.receiveAmount,
                                callback: function ($$v) {
                                  _vm.receiveAmount = $$v
                                },
                                expression: "receiveAmount",
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "suffix" }, slot: "suffix" },
                                [_vm._v(" USD ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "source", label: "类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.source,
                                callback: function ($$v) {
                                  _vm.source = $$v
                                },
                                expression: "source",
                              },
                            },
                            _vm._l(_vm.options, function (item, $index) {
                              return _c("el-option", {
                                key: $index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "receiveAmount", label: "文件" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "#",
                                limit: 1,
                                "show-file-list": false,
                                "http-request": _vm.httpRequest,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "small" },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      iconClass: "upload",
                                      className: "icon",
                                    },
                                  }),
                                  _vm._v(" 选择文件上传 "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          staticStyle: { "margin-top": "30px" },
                          attrs: { size: "small" },
                          on: { click: _vm.ok },
                        },
                        [_vm._v("确定上传")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BaseTable", {
            staticStyle: { "margin-top": "10px" },
            attrs: {
              height: 400,
              tableData: _vm.tableData,
              isPager: false,
              isEmptyBorder: true,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "opt",
                  fn: function (row) {
                    return row.scope.fileName
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.review(row.scope)
                                },
                              },
                            },
                            [_vm._v("预览")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "24px" },
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.download(row.scope)
                                },
                              },
                            },
                            [_vm._v("下载")]
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }